import { render, staticRenderFns } from "./main_category.vue?vue&type=template&id=35eb7860&scoped=true&"
import script from "./main_category.vue?vue&type=script&lang=js&"
export * from "./main_category.vue?vue&type=script&lang=js&"
import style0 from "./main_category.vue?vue&type=style&index=0&id=35eb7860&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35eb7860",
  null
  
)

export default component.exports